import { Component } from '@verndale/core';
import Swiper, { Navigation, Pagination } from 'swiper';
import { BREAKPOINTS } from '../utils';

Swiper.use([Navigation, Pagination]);

class CampaignCarousel extends Component {
  setupDefaults() {
    this.dom = {
      $heading: this.el.querySelector('.campaign-carousel__heading'),
      $link: this.el.querySelector('.campaign-carousel__link'),
      $slides: this.el.querySelectorAll('.swiper-slide'),
      $swiperContainer: this.el.querySelector('.swiper'),
      $swiperSlides: this.el.querySelectorAll('.swiper-slide'),
      $swiperPagination: this.el.querySelector('.swiper-pagination'),
      $swiperNextButton: this.el.querySelector('.swiper-button-next'),
      $swiperPrevButton: this.el.querySelector('.swiper-button-prev')
    };

    this.checkSize();
    this.initSwiper();
  }

  addListeners() {
    window.addEventListener('resize', this.checkSize.bind(this));
  }

  checkSize() {
    this.isMobile = window.matchMedia(
      `(max-width: ${BREAKPOINTS.TABLET_LANDSCAPE - 1}px)`
    ).matches;
  }

  disableNonActiveSlides(slides) {
    slides.forEach((slide) => {
      if (
        (!slide.className.includes('swiper-slide-active') &&
          !slide.className.includes('swiper-slide-next')) ||
        this.isMobile
      ) {
        slide.querySelector('article').style.visibility = 'hidden';
      } else {
        slide.querySelector('article').style.visibility = 'visible';
      }
      if (slide.className.includes('swiper-slide-active')) {
        slide.querySelector('article').style.visibility = 'visible';
      }
    });
  }

  initSwiper() {
    this.swiper = new Swiper(this.dom.$swiperContainer, {
      a11y: true,
      centeredSlides: true,
      watchSlidesProgress: true,
      direction: 'horizontal',
      rewind: true,
      slidesPerView: 1,
      breakpoints: {
        [BREAKPOINTS.TABLET_LANDSCAPE]: {
          allowTouchMove: false,
          centeredSlides: false,
          slidesPerGroup: 1,
          slidesPerView: 1,
          spaceBetween: 0,
          pagination: {
            type: 'bullets'
          }
        }
      },
      pagination: {
        el: this.dom.$swiperPagination,
        type: 'fraction'
      },
      navigation: {
        nextEl: this.dom.$swiperNextButton,
        prevEl: this.dom.$swiperPrevButton
      }
    });
  }
}

export default CampaignCarousel;
